import { render, staticRenderFns } from "./AdditionalFieldsDtek.vue?vue&type=template&id=4dc41897&scoped=true"
import script from "./AdditionalFieldsDtek.vue?vue&type=script&lang=js"
export * from "./AdditionalFieldsDtek.vue?vue&type=script&lang=js"
import style0 from "./AdditionalFieldsDtek.vue?vue&type=style&index=0&id=4dc41897&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dc41897",
  null
  
)

export default component.exports